import React, { FC } from 'react';
import { Form } from 'react-bootstrap';
import { IComponentKey } from 'src/interfaces';
import { IconLabel } from 'src/libs/ui-kit/IconLabel/IconLabel';

export interface IUserContactRowTableProps extends IComponentKey {
  value: string;
  isVerified: boolean;
  isMain: boolean;
  isDeleted: boolean;
  isAwaitingDeleteRestore: boolean;
  onChange(): void;
  onDeleteClick(): void;
}

export const UserContactTableRow: FC<IUserContactRowTableProps> = (props) => (
  <tr>
    <td>{props.value}</td>
    <td>{props.isVerified && <IconLabel success text="Да" />}</td>
    <td>
      <Form.Check type="radio" checked={props.isMain} />
    </td>
    <td>{props.isDeleted ? <IconLabel success={false} text="Нет" /> : <IconLabel success text="Да" />}</td>
  </tr>
);
